<script setup lang="ts">

import { useViewModel } from "./SetHomeDealershipModel";
import { useAppConfiguration } from "@domain/AppConfiguration";

const model = useViewModel();
const app = useAppConfiguration();

</script>

<template>

    <div class="dark:bg-gray-900
                w-full h-full overflow-y-auto flex flex-col pb-12">
    
        <div class="px-4 pb-4 lg:pb-6 3xl:pb-8 flex flex-col gap-4
                    bg-gradient-to-b dark:from-gray-900 via-30% dark:to-gray-800/80
                    shadow-sm z-10">

            <div class="flex justify-center items-center mt-6">
                <strong class="text-lg 3xl:text-xl font-bold">
                    {{ app.isGeneric ? 'Set' : 'Change' }} Your Home Dealership
                </strong>
            </div>     

            <p class="text-center text-base lg:text-base 3xl:text-xl opacity-60">
                When you set your home dealership you get access to exclusive offers 
                to reduce the cost of maintaining your car
            </p>

            <p class="text-center text-base lg:text-base 3xl:text-xl">
                But you'll need a reward code from the dealership to unlock their offers!
            </p>

            <p class="text-center text-base lg:text-base 3xl:text-xl opacity-60">
                Just enter your reward code below and start saving on your automotive costs
            </p>
            
            <v-otp-input type="number"
                         v-model="model.originatorCode"
                         length="6"
                         :autofocus="true"
                         class="-my-2 3xl:my-0">
            </v-otp-input>

            <Button variant="tonal" 
                    class="!h-10 lg:!h-12 mx-auto"
                    :disabled="model.originatorCode.length < 6" 
                    @click="() => model.onSubmitCode()">
                <span v-if="app.isGeneric">
                    Unlock Automotive Rewards
                </span>

                <span v-else>
                    Change Dealership
                </span>
            </Button>

        </div>

        <div class="text-center p-4 lg:p-6 3xl:p-8 flex flex-col gap-4
                    bg-gradient-to-b dark:from-gray-800/65 dark:to-gray-900">
            <h1 class="text-base 3xl:text-xl">
                Don't have {{ app.isGeneric ? 'a' : 'their' }} reward code?
            </h1>
            <p class="text-sm lg:text-base 3xl:text-xl opacity-60">
                If you don't have {{ app.isGeneric ? 'a' : 'their' }} code or you've misplaced it, you can still get one from your local dealership!
            </p>
            <p class="text-sm lg:text-base 3xl:text-xl">
                Just give them a call and ask for their 
                <span class="text-secondary-400 font-bold uppercase">"Carbucks Reward Code"</span>
            </p>

        </div>

    </div>

</template>